import gql from 'graphql-tag'

export const insertLink = ({ linkData, linkRoles }) => {
	return {
		mutation: gql`
			mutation insertSinglelink($link: links_insert_input!) {
				insert_links_one(object: $link) {
					id
				}
			}
		`,
		variables: {
			link: {
				link_name: linkData.name,
				country_id: linkData.country_id,
				link_url: linkData.url,
				order: linkData.order,
				publishing_date: linkData.publishing_date,
				links_roles: {
					data: linkRoles.map(rol => ({
						rol_id: rol.id
					}))
				}
			}
		}
	}
}
